import { formatDate as formatDateUtil } from 'lib/helpers/dateUtils';

const momentToDateFnsFormat = (fmt) => {
  return fmt
    .replace(/YYYY/g, 'yyyy')
    .replace(/YY/g, 'yy')
    .replace(/DD/g, 'dd')
    .replace(/D/g, 'd')
    .replace(/A/g, 'a');
};

export const formatDate = ({ date, format = 'MM/DD/YYYY', tz = null }) => {
  const convertedFormat = momentToDateFnsFormat(format);
  return formatDateUtil(date, tz, convertedFormat);
};
